import React from 'react';
import { withTheme } from 'styled-components';
import { Page, PageTitle, Header } from './partials';
export var CategoryHeader = function CategoryHeader(_ref) {
  var theme = _ref.theme,
    category = _ref.category;
  return React.createElement(Header, null, React.createElement(Page, {
    justify: "space-between"
  }, React.createElement(PageTitle, {
    as: theme.partner.headings.title,
    large: true
  }, category.name)));
};
export default withTheme(CategoryHeader);